export enum PainelPermissionsPath {
    HOME,
    SCHOOL_PLAN,
    CLASSES,
    SUBJECTS,
    TEACHERS,
    STUDENTS,
    ROLES_AND_PERMISSIONS,
    UNKNOWN = -1
  }

export const PermissionsDetails: Record<
  PainelPermissionsPath,
  { title: string; url: string; description: string }
> = {
  [PainelPermissionsPath.HOME]: {
    title: "Início",
    description: "Acesso à página inicial do painel.",
    url: "main",
  },
  [PainelPermissionsPath.SCHOOL_PLAN]: {
    title: "Plano Letivo",
    description: "Gerenciar o plano letivo da escola.",
    url: "planoletivo",
  },
  [PainelPermissionsPath.CLASSES]: {
    title: "Turmas",
    description: "Gerenciar as turmas da escola.",
    url: "turma",
  },
  [PainelPermissionsPath.SUBJECTS]: {
    title: "Disciplina",
    description: "Gerenciar as disciplinas oferecidas.",
    url: "disciplina",
  },
  [PainelPermissionsPath.TEACHERS]: {
    title: "Professores",
    description: "Gerenciar os professores da escola.",
    url: "professores",
  },
  [PainelPermissionsPath.STUDENTS]: {
    title: "Alunos",
    description: "Gerenciar os alunos da escola.",
    url: "aluno",
  },
  [PainelPermissionsPath.UNKNOWN]: {
    title: "",
    url: "",
    description: ""
  },
  [PainelPermissionsPath.ROLES_AND_PERMISSIONS]: {
    title: "",
    url: "",
    description: ""
  }
};
